import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

function Card({ offering }) {
  const navigate = useNavigate();

  const exploreBooks = () => {
    navigate('/offerings/books/' + offering.courseName.replace(/\s+/g, '').toLowerCase());
  };

  return (
    <Box>
      <Paper
        sx={{
          height: '700px',
          maxWidth: '400px',
          borderRadius: '10px',
          textAlign: 'center',
          justifyItems: 'center',
          py: '10px',
        }}
      >
        <Box sx={{ height: '200px' }}>
          <img
            src={`${offering.image}`}
            width="100%"
            alt={offering.courseName}
          />
        </Box>

        <Typography variant="h6" color="#3a96d7">
          <strong>{offering.courseName}</strong>
        </Typography>
        <br />

        <Box bgcolor="#fecc00" sx={{ boxShadow: 5, width: '130px', p: '3px', fontSize: '18px' }}>
          {offering.grade}
        </Box>

        <br />

        <Box sx={{ p: 2, textAlign: 'justify', height: '130px', fontSize: '16px' }}>
          {offering.description}
        </Box>
        <br />

        <Box>
          <Grid container>
            <Grid item>
              <Box
                bgcolor="#e27dbb"
                sx={{
                  p: '5px',
                  height: '30px',
                  width: '30px',
                  color: 'white',
                  fontSize: '25px',
                }}
              >
                <strong>{offering.chapterCount}</strong>
              </Box>
            </Grid>
            <Grid item>
              <Box py="5px" sx={{ alignItems: 'center' }}>
                <Box
                  bgcolor="green"
                  sx={{
                    height: '30px',
                    color: 'white',
                    fontSize: '17px',
                    px: '4px',
                    alignContent: 'center',
                  }}
                >
                  <strong>CHAPTERS</strong>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <br />

        <Box sx={{ width: '120px', color: 'white', bgcolor: 'green' }}>
          <Grid>
            <Grid>
              <Box
                width="100%"
                sx={{
                  bgcolor: '#2f217c',
                  height: '40px',
                  alignContent: 'center',
                  fontSize: '20px',
                }}
              >
                <strong>{offering.periods}</strong>
              </Box>
              <Box sx={{ bgcolor: '#3a96d7', fontSize: '18px', p: 1, width: '104px' }}>
                <strong>PERIODS</strong>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <br />


        {/* Explore Button */}
        <Button
          variant="contained"
          color="grey"
          href={offering.pageUrl}
          sx={{ fontSize: '16px' }}
          onClick={exploreBooks}
        >
          EXPLORE
        </Button>
      </Paper>
    </Box>
  );
}

export function CSOffering() {
  const [offeringData, setOfferingData] = useState([]);
  //const [isAdmin, setIsAdmin] = useState(false);
  //const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  // const [newOffering, setNewOffering] = useState({
  //   courseName: '',
  //   description: '',
  //   grade: '',
  //   chapterCount: '',
  //   periods: '',
  //   image: '',
  // });

  useEffect(() => {
    const fetchOfferings = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/weoffer`);
        const data = response.data;
        const sortedData = data.sort((a, b) => a.order - b.order);
        const newData = sortedData.filter((a) => a.isVisible === true && a.type === 'book');
        setOfferingData(newData);
      } catch (error) {
        console.error('Error fetching offerings:', error);
      }
    };


    fetchOfferings();
  }, []);

  return (
    <Box>
      <Box>
        <Grid container direction="row" sx={{
          justifyContent: "center",
          alignItems: "center",
        }}>
          {offeringData.map((offering) => (
            <Grid item xs={12} md={3} key={offering._id}>
              <Box sx={{ px: 1, py: 1 }}>
                <Card offering={offering} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
